<template>
  <div class="kye-upload-container">
    <el-upload :action="uploadUrl"
              :headers="headers"
              :on-success="handleSuccess"
              :on-change="handleChange"
              :show-file-list="_showFileList"
              :before-remove="beforeRemove"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-upload="handleBeforeUpload"
              :file-list="value"
              :data="fileData"
              v-bind="attr || $attrs"
              :accept="currentAccept"
              :disabled="disabled"
              ref="upload"
              v-on="$listeners">
      <kye-button v-if="!isCardMode"
                :disabled="disabled"
                :auth="auth"
                :type="btnType"
                :icon="btnIcon">{{btnText}}</kye-button>
      <div :style="{pointerEvents: disabled ? 'none' : ''}"
          v-else-if="isCardMode">
        <i class="el-icon-plus"></i>
      </div>
      <template slot="tip">
        <slot name="tip"></slot>
      </template>
    </el-upload>

    <slot name="fileList" v-if="showFileList">
      <!-- 默认预览 -->
      <FileList
        v-if="value && value.length"
        :disabled="disabled"
        :files="value"
        @deleteFile="deleteFile"
        @previewFile="previewFile"
        @download="downloadFile" />
    </slot>
  </div>
</template>

<script>
  import { getToken } from 'public/utils'
  import { isEncryptedByVideoFile } from 'public/utils/safety'
  import { ENV } from 'public/config'
  import FileList from './file-list.vue'
  import openPreview from 'public/components/kye-preview/preview'

  const isProd = ENV === 'prd'

  export default {
    name: 'kye-upload',
    components: {
      FileList
    },
    props: {
      value: Array,
      code: String,
      id: String,
      extParams: {
        type: Object,
        default: () => ({})
      },
      btnIcon: {
        type: String,
        default: 'layout layout-shangchuan'
      },
      btnType: {
        type: String,
        default: 'primary'
      },
      btnText: {
        type: String,
        default: '上传文件'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      beforeUpload: {
        type: Function,
      },
      accept: Array,
      size: Number,
      replace: Boolean,
      fileId: String,
      attr: Object,
      successMsg: {
        type: String,
        default: '上传成功'
      },
      auth: String,
      validateVideo: { // 校验视频文件是否加密
        type: Boolean,
        default: true
      },
      beforeRemoveFn: Function
    },
    data () {
      return {
        count: 0,
        num: 0,
        // signature: null,
        accepts: {
          excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/kset',
          word: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/kswps',
          pdf: 'application/pdf, application/kswps',
          image: 'image/gif, image/jpeg, image/png, image/x-ms-bmp',
          zip: 'application/zip, application/x-zip-compressed',
          ppt: `application/vnd.ms-powerpoint,
            application/vnd.ms-powerpoint,
            application/vnd.ms-powerpoint,
            application/vnd.openxmlformats-officedocument.presentationml.template,
            application/vnd.openxmlformats-officedocument.presentationml.slideshow,
            application/vnd.openxmlformats-officedocument.presentationml.presentation`
        },
        isInAccept: true
      }
    },
    computed: {
      uploadUrl () {
        return `/router/upload`
      },
      fileData () {
        let obj = {
          bizCode: (this.code && typeof this.code === 'string') ? this.code.replace(/\./g, '_') : this.code,
          bizId: this.id,
          num: this.num,
          // signature: this.signature,
          ...this.extParams,
          token: getToken(),
          'x-uid': this.$store.getters.user.id
        }
        if (this.replace) {
          obj.id = this.fileId
        }
        return obj
      },
      currentAccept () {
        if (this.accept) {
          return this.accept.map(k => this.accepts[k] ? this.accepts[k] : k).join(',')
        }
        return ''
      },
      // 兼容泳道环境添加ENV-id
      headers() {
        if (isProd) {
          return {}
        }
        const multiSessionStr = sessionStorage.getItem('ERPMULTIMODULE')
        if (multiSessionStr) {
          const multiSessionData = JSON.parse(multiSessionStr)
          const envId = multiSessionData.envId
          if (envId) {
            return {
              'x-envid': envId
            }
          }
        }
        return {}
      },
      isPictureCartMode() {
        return this.$attrs['list-type'] === 'picture'
      },
      isCardMode() {
        return this.$attrs['list-type'] === 'picture-card'
      },
      _showFileList() {
        if (!this.isCardMode && !this.isPictureCartMode) {
          return false
        }
        return this.$attrs['show-file-list']
      },
      showFileList() {
        if (this.$attrs['show-file-list'] === false) {
          return false
        }
        if (this.isCardMode || this.isPictureCartMode) {
          return false
        }
        return true
      },
    },
    methods: {
      // getSign () {
      //   if (!this.signature) {
      //     this.count = this.count + 1
      //     let params = { args: { code: this.code }, timeout: 300 }
      //     this.$http('openapi.signature', params).then(data => {
      //       this.signature = data
      //     }).catch(err => {
      //       console.log(err)
      //       if (this.count < 4) {
      //         this.getSign()
      //       } else {
      //         this.$message.error('签名失败')
      //       }
      //     })
      //   }
      // },
      handleChange (file, list) {
        this.num = list.length
      },
      handleSuccess (res, file, list) {
        this.num = 0
        // 上传文件大小为0kb的不往下走
        if (file.size === 0) {
          this.$message.warning(`文件大小不能为0KB!`)
          this.$emit('error', res, file, list)
          return
        }
        if (res.code === 0) {
          this.$emit('input', res.data, list)
          this.$emit('success', res.data, list)
          this.successMsg && this.$message.success(this.successMsg)
        } else {
          this.$emit('error', res, file, list)
          this.$message.warning(res.msg || res.message || '上传失败')
        }
      },
      beforeRemove (file, list) {
        const isNext = typeof this.$props.beforeRemoveFn === 'function' ? this.$props.beforeRemoveFn(file, list) : true
        if (!isNext) return false

        if (!(this.size && file.size > this.size * 1024 * 1024) && this.isInAccept && file.status === 'success') {
          return this.$confirm('此操作将永久删除该文件, 是否继续?', '提示')
        }
      },
      handleRemove (file, list) {
        if (file && file.status === 'success' && file.bizCode && file.bizId && file.id) {
          let params = { bizCode: file.bizCode, bizId: file.bizId, id: file.id }
          this.$http('file.deleteByBizAndId', params).then(res => {
            if (res) {
              let arr = JSON.parse(JSON.stringify(this.value))
              let index = arr.findIndex(t => t.id === params.id)
              arr.splice(index, 1)
              this.$emit('input', arr)
              this.$emit('delete-success', arr)
              this.$message.success('删除成功')
            }
          })
        }
      },
      handlePreview (file) {
        if (this.$attrs['on-preview']) {
          this.$attrs['on-preview'](file)
        } else {
          window.erpOpen(file.url)
        }
      },
      handleBeforeUpload (file) {
        return new Promise(async (resolve, reject) => {
          try {
            if (this.validateVideo) {
              const isEncrypted = await isEncryptedByVideoFile(file)
              if (isEncrypted) {
                // eslint-disable-next-line prefer-promise-reject-errors
                reject(false)
                return
              }
            }

            if (this.size && file.size > this.size * 1024 * 1024) {
              this.$message.warning(`文件大小不能超过${this.size}MB!`)
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(false)
              return
            }
            if (this.beforeUpload && typeof this.beforeUpload === 'function') {
              let userUpload = this.beforeUpload(file)
              if (userUpload && userUpload.then) {
                userUpload = await userUpload
              }
              if (userUpload === false) {
                // eslint-disable-next-line prefer-promise-reject-errors
                reject(false)
                return
              }
            }
          } catch (error) {
            reject(error)
          }
          resolve()
        })
        /* if (this.accept && this.accept.length) {
          this.isInAccept = true
          let type = file.type || `.${file.name.split('.').pop()}`
          if (this.currentAccept.indexOf(type) === -1) {
            this.isInAccept = false
            this.$message.warning(`文件类型与要求不符`)
            return false
          }
        } */
      },
      // 手动调用upload上传组件
      manualUpload () {
        this.$refs.upload.$children[0].handleClick()
      },
      deleteFile(index) {
        const before = this.beforeRemove(this.value[index], this.value)
        if (before && before.then) {
          before.then(
            () => {
              this.handleRemove(this.value[index], this.value)
            },
            () => {}
          )
        } else if (before !== false) {
          this.handleRemove(this.value[index], this.value)
        }
      },
      previewFile(file, index = 0) {
        let config = {
          ...this.$props.previewOptions
        }
        if (Array.isArray(file)) {
          config.mustPreivewType = [
            'text',
            'xml',
            'zip',
            'mp3',
            'mp4',
            'aac',
            'wav',
            'v3',
            'heic',
            'xmind',
            'mmap',
            'rar',
            'txt'
          ]
          config.list = file
          config.index = index
          config.isPrewFileToPdf = true
        } else {
          config = {
            fileName: file.name,
            extendName: file.extendName,
            id: file.id,
            url: file.url,
            ...this.$props.previewOptions
          }
        }
        openPreview(config)
      },
      downloadFile(file) {
        const { url } = file
        if (url) {
          window.erpOpen(url)
        } else {
          this.$message.error('下载地址不存在')
        }
      }
    }
  }
</script>

<style lang="less">
.kye-upload {
  &-container {
    .kye-upload-list {
      padding: 0;
      display: inline-block;
      margin: 0;
      margin-top: 4px;
      border: none;
      .kye-upload-list_item {
        margin-top: 4px;
        border: 1px solid #e6e7ea;
        border-radius: 4px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-upload/index.vue